<template>
    <el-alert v-if="errorMessage" type="error" class="error-alert">
        <span> {{ errorMessage }} </span>
        <el-icon class="close-icon fas fa-times" @click="onClose" />
    </el-alert>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';

const ErrorAlert = defineComponent({
    setup() {
        const store = useStore();
        const errorMessage = computed(() => {
            return store.state.errors.errorMessage;
        });

        const onClose = () => {
            return store.commit('errors/RESET_ERROR_MESSAGE');
        };
        return {
            errorMessage,
            onClose,
        };
    },
});
export default ErrorAlert;
</script>
<style scoped lang="scss">
.error-alert {
    /*position: sticky;
  top: 0;
  z-index: 5;*/
}
.close-icon {
    position: absolute !important;
    right: 10px;
    cursor: pointer;
}
</style>
